import ListFieldsGeneric from './ListFieldsGeneric'
import publikationsTyp from '../PublikationsTyp'
let ListFields = ListFieldsGeneric('Publikation')

export default {
  label: 'Publikation',
  route: 'publikation',
  className: 'publikation',
  fields: [
    ListFields.SortableTimestamp('_updateDate', false, 'updateDate', true),
    ListFields.SortableTimestamp('_createDate', false, 'createDate', true),
    ListFields.SortableReference('organisationseinheit', false),
    ListFields.UnsortableReference('weitereOrganisationseinheiten', false),
    {
      ...publikationsTyp,
      label: `Publikation.list.column.publikationsTyp`,
      field: 'publikationsTyp',
      tableVisible: true,
      sortable: true,
      sortField: 'publikationsTyp',
      type: 'select',
      plain: true
    },
    ListFields.UnsortableReference('author', true),
    ListFields.UnsortableReference('herausgeber', false),
    ListFields.SortableField('titelPublikation', true),
    ListFields.SortableField('veroeffentlichungsJahr', true),
    ListFields.UnsortableReference('publicPubIdent', false),
    ListFields.SortableBoolean('validiert', false),
    ListFields.SortableBoolean('istFinal', false)
  ]
}



// WEBPACK FOOTER //
// ./src/schema/list/Publikation.js